export const STATES = {
  CREATED: 'created',
  AWAITING_VALIDATION: 'awaitingValidation',
  AWAITING_NOTARY: 'awaitingNotary',
  AWAITING_SIGN: 'awaitingSign',
  SENDED: 'sended',
  VALIDATE_BY_ALL: 'validatedByAll',
  FINALIZED: 'finalized',
  CANCELED: 'canceled',
  HALT: 'halted',
  OBJECTED: 'objected',
  DRAFT: 'draft',
  MODIFIED_PDF: 'modifiedPdf',
  APPEALED: 'appealed'
};

export const ROLES = {
  LESSEE: 'arrendatario',
  LESSOR: 'arrendador',
  CODEBTOR: 'codeudor',
  OWNER: 'owner',
  ADMIN: 'admin',
  LESSEES: 'arrendatarios',
  CODEBTORS: 'codeudores'
};

export const ACTIONS = {
  LESSOR_VALIDATE: 'lessorValidate',
  LESSOR_OBJECT: 'lessorObject',
  LESSOR_SIGN: 'lessorSign',
  LESSEE_VALIDATE: 'lesseeValidate',
  LESSEE_OBJECT: 'lesseeObject',
  LESSEE_SIGN: 'lesseeSign',
  CODEBTOR_VALIDATE: 'codebtorValidate',
  CODEBTOR_OBJECT: 'codebtorObject',
  CODEBTOR_SIGN: 'codebtorSign',
  ADMIN_OBJECT: 'adminObject',
  ADMIN_EDIT_PDF: 'adminEditPdf'
};

export const spStates = (state) => {
  switch (state) {
    case STATES.CREATED:
      return 'Pagado';
    case STATES.AWAITING_VALIDATION:
      return 'Esperando validación';
    case STATES.VALIDATE_BY_ALL:
      return 'Validado por todos';
    case STATES.FINALIZED:
      return 'Finalizado';
    case STATES.CANCELED:
      return 'Anulado';
    case STATES.HALT:
      return 'Detenido';
    case STATES.OBJECTED:
      return 'Objetado';
    case STATES.AWAITING_NOTARY:
      return 'Esperando firma de notario';
    case STATES.AWAITING_SIGN:
      return 'Esperando firmas';
    case STATES.SENDED:
      return 'Esperando firmas';
    case STATES.DRAFT:
      return 'Borrador no pagado';
    case STATES.APPEALED:
      return 'Esperando evidencia';
  };
};